<template>
  <v-container fluid class="py-0">
    <heading />
  </v-container>
</template>

<script>
import Heading from "./components/Heading";

export default {
  mixins: [],
  components: {
    Heading,
  },
  data: () => ({}),
  computed: {},
  watch: {},
  created: async function () {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
